import styled from 'styled-components';
import Container from '~/grid/Container';
import { mq } from '~/styles/grid';
import CTA from '../../../atoms/CTA';
import { CTAIconPosition } from '../../../atoms/CTA/CTA.constants';
import { Headline500 } from '../../../atoms/Headline';
import { HeadlineLevel } from '../../../atoms/Headline/Headline';
import getSocialChannel from '~/helpers/getSocialChannel';
import { useIntl } from 'react-intl';

const ContainerStyled = styled(Container)`
  display: flex;
  flex-direction: ${(props) => props.fd};
  align-items: ${(props) => props.ai};
  gap: 25px;

  @media (${mq.smDown}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
`;

const ChannelsWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 15px;

  @media (${mq.smDown}) {
    margin: ${(props) => (props.fd === 'column' ? '0 0 20px' : '20px 0')};
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  a {
    height: 40px;
    width: 40px;
    background-color: transparent;
    color: ${(props) => props.theme.color.white500};
    transition: background-color 0.25s ease-out;
    display: flex;
    align-items: center;
    justify-content: center;

    &:last-of-type {
      margin-right: 0;
    }

    svg {
      max-width: 21px;
      max-height: 21px;
      width: 100%;
      height: 100%;
    }
    &:hover span svg path {
      fill: ${(props) => props.theme.color.cta};
    }
  }

  svg {
    path {
      fill: ${(props) => props.theme.color.white500};
    }
  }
`;

const Description = styled(Headline500)`
  color: ${(props) => props.color ?? props.theme.color.white500};

  @media (${mq.lgUp}) {
    margin-bottom: ${(props) =>
      props.marginBottom ? `${props.marginBottom}rem` : 0};
  }

  @media (${mq.xs}) {
    margin: 0 0 15px 0;
  }
`;

/**
 * @param {SocialMediaButtonsProps} props
 * @returns {React.ReactElement | null} The rendered component
 */
const SocialMediaButtons = ({
  color,
  socialMediaLink,
  channels,
  flexDirection = 'row',
  alignItems = 'center',
  headlineMb = 0,
  headlineLevel = HeadlineLevel.h4,
}) => {
  const intl = useIntl();

  if (channels && channels.length > 0) {
    return (
      <ContainerStyled
        fd={flexDirection}
        ai={alignItems}
        data-id="social-media-buttons-container"
      >
        <Description
          level={headlineLevel}
          color={color}
          marginBottom={headlineMb}
        >
          {intl.formatMessage({
            id: 'main.followUs',
          })}
        </Description>
        <ChannelsWrapper fd={flexDirection}>
          {channels.map((channel) => {
            return getSocialChannel(channel, color);
          })}
        </ChannelsWrapper>
        {socialMediaLink && (
          <CTA
            skin="NAVIGATION_FOOTER"
            target="_blank"
            icon="ARROW_ANIMATION"
            iconPos={CTAIconPosition.Before}
            isBrand
            {...socialMediaLink}
          />
        )}
      </ContainerStyled>
    );
  }
  return null;
};

export default SocialMediaButtons;
